var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.product
    ? _c("div", { staticClass: "product-display" }, [
        _c("div", { staticClass: "product-display__wrapper" }, [
          _c("div", { staticClass: "container" }, [
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "small-12 medium-5 column" },
                [
                  _c("product-media-gallery", {
                    attrs: { product: _vm.product, images: _vm.product.images }
                  }),
                  _vm.$mq !== "mobile"
                    ? _c("product-accordians", {
                        staticClass: "product-display__product-accordion",
                        attrs: {
                          product: _vm.product,
                          id: "more_details_accordion"
                        }
                      })
                    : _vm._e()
                ],
                1
              ),
              _c("div", { staticClass: "small-12 medium-7 column" }, [
                _c(
                  "div",
                  { staticClass: "product-info-container" },
                  [
                    _c("product-info", {
                      attrs: {
                        product: _vm.product,
                        "title-image": _vm.titleImage
                      }
                    }),
                    _vm.product.type === "Gift Card"
                      ? _c("product-form-gift-card", {
                          attrs: { product: _vm.product }
                        })
                      : _c("product-form", { attrs: { product: _vm.product } }),
                    _vm._t("promo-image"),
                    _vm.$mq === "mobile"
                      ? _c("product-accordians", {
                          staticClass: "product-display__product-accordion",
                          attrs: {
                            product: _vm.product,
                            id: "more_details_accordion"
                          }
                        })
                      : _vm._e()
                  ],
                  2
                )
              ])
            ])
          ])
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }